const BannerCarousel = ({ sectionId, steps }) => {
  const normalizedSteps = steps.map((el) => {
    return {
      ...el,
      image: {
        src: el.image.url,
        alt: el.image.alternativeText
      }
    }
  })

  const normalizedData = {
    sectionId,
    steps: normalizedSteps,
  }

  return normalizedData
}

export default BannerCarousel
